import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Create category", -1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = {
  key: 0,
  class: "text-danger validation-summary-errors",
  "data-valmsg-summary": "true"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Kategooria nimi", -1)
const _hoisted_8 = { class: "form-group row p-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 p-2 control-label" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Kategooria pilt")
], -1)
const _hoisted_10 = { class: "col-8 p-2" }
const _hoisted_11 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_upload_image = _resolveComponent("upload-image")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.errorMsg != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(_ctx.errorMsg), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.categoryParentCategoryId) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (asd) => {
              return (_openBlock(), _createElementBlock("option", {
                key: asd.id,
                value: asd.id
              }, _toDisplayString(asd.name), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.categoryParentCategoryId]
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.categoryName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.categoryName]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_upload_image)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("input", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitClicked())),
              type: "submit",
              value: "Create",
              class: "btn btn-primary"
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_RouterLink, { to: { name: 'categories' } }, {
        default: _withCtx(() => [
          _createTextVNode("Back to Categories")
        ]),
        _: 1
      })
    ])
  ], 64))
}